
<router-outlet></router-outlet>

<div *ngIf='pleasStatus'>
    <div class='overlay'></div>
    <div class='wait'> אנא המתן </div>
</div>
